const typographyModalCloneCheckSite = {
  text: 'Clonar Tipos de Serviço'
};

export default typographyModalCloneCheckSite;
